/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';
import rootReducer from './reducers/index';
import VersionHandler from './utils/VersionHandlerService';
import { serializeRouteState } from './reducers/routeSelector-reducer';

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : (f) => f;

VersionHandler.checkAppVersion();

const enhancer = compose(
  applyMiddleware(thunk.withExtraArgument()),
  persistState(
    ['form', 'logbooks', 'routingTable', 'maps', 'routes', 'ships', 'modals'],
    {
      slicer: () => (state) => {
        return {
          ...state,
          routes: serializeRouteState(state.routes),
        };
      },
    }
  ),
  devTools
);

function configureStore(initialState) {
  return createStore(rootReducer, enhancer, initialState);
}

export const store = configureStore();
